import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CountrySelectionService } from './country-selection.service';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MedicineReminderService {

  constructor(private http: HttpClient, private countrySelectionService: CountrySelectionService) { }

  submitMedicineReminder(data: any): Observable<any> {
    return this.countrySelectionService.selectedCountry$.pipe(
      switchMap(country => {
        const apiUrl = this.countrySelectionService.getApiUrl('medicine_reminder', country);
        return this.http.post(apiUrl, data);
      })
    );
  }

  getMedicineReminderContent(): Observable<any> {
    return this.countrySelectionService.selectedCountry$.pipe(
      switchMap(country => {
        const apiUrl = this.countrySelectionService.getApiUrl('get_medicine_reminder_content', country);
        return this.http.get<any[]>(apiUrl);
      })
    );
  }
}
